import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getUser } from '../helpers/DecodeJWT';
import { hasPrivilege } from './privileges';

export default function RequirePrivilege({ privilege, children }) {
  const user = getUser();
  const role = user?.role;

  if (!hasPrivilege(role, privilege)) {
    return <Navigate to="/404" replace />;
  }

  return children;
}

RequirePrivilege.propTypes = {
  privilege: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

